import * as zod from 'zod';

// Common fields for all weld machine states
export const BaseWeldMachineState = zod.object({
  // This boolean determines whether we show the welding arc flash effect in the visualizer.
  // The visualizer doesn't have access to the routineRunnerState, so we plumb this through
  // via the WeldMachineState.
  isWelding: zod.boolean(),
  /**
   * Whether the transport to the machine is currently up, read from the Modbus
   * connection rather than from anything the machine reports.
   *
   * The machine's own status bits (Miller's `discreteInputs.ready`, ESAB's
   * `isReady`) are not liveness signals: the Modbus layer caches the last
   * successfully-read value and never invalidates it on a dropped socket, so
   * those bits latch at their last-known value while the machine is offline.
   * Connection state has to come from the transport for
   * connected/disconnected to mean anything.
   */
  isConnected: zod.boolean(),
});

export type BaseWeldMachineState = zod.infer<typeof BaseWeldMachineState>;
